export const FETCH_STATS_POOL = 'FETCH_STATS_POOL';
export const FETCH_STATS_POOL_SUCCESS = 'FETCH_STATS_POOL_SUCCESS';
export const FETCH_STATS_POOL_FAILED = 'FETCH_STATS_POOL_FAILED';
export const FETCH_STATS_USER = 'FETCH_STATS_USER';
export const FETCH_STATS_USER_SUCCESS = 'FETCH_STATS_USER_SUCCESS';
export const FETCH_STATS_USER_FAILED = 'FETCH_STATS_USER_FAILED';
export const FETCH_STATS_LANDING = 'FETCH_STATS_LANDING';
export const FETCH_STATS_LANDING_SUCCESS = 'FETCH_STATS_LANDING_SUCCESS';

export const FETCH_FOUND_BLOCKS = 'FETCH_FOUND_BLOCKS';
export const FETCH_FOUND_BLOCKS_SUCCESS = 'FETCH_FOUND_BLOCKS_SUCCESS';
export const FETCH_FOUND_BLOCKS_FAILED = 'FETCH_FOUND_BLOCKS_FAILED';

export const FETCH_MINING_WORKERS = 'FETCH_MINING_WORKERS';
export const FETCH_MINING_WORKERS_SUCCESS = 'FETCH_MINING_WORKERS_SUCCESS';
export const FETCH_MINING_WORKERS_FAILED = 'FETCH_MINING_WORKERS_FAILED';

export const FETCH_EARNINGS = 'FETCH_EARNINGS';
export const FETCH_EARNINGS_SUCCESS = 'FETCH_EARNINGS_SUCCESS';
export const FETCH_EARNINGS_FAILED = 'FETCH_EARNINGS_FAILED';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const LOG_OUT = 'LOG_OUT';
export const LOG_IN = 'LOG_IN';
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export const LOG_IN_FAILED = 'LOG_IN_FAILED';

export const SIGN_UP = 'SIGN_UP';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILED = 'SIGN_UP_FAILED';

export const APP_ERROR = 'APP_ERROR';
export const BAD_REQUEST = 'BAD_REQUEST';
export const NOT_FOUND = 'NOT_FOUND';
export const AUTH_ERROR = 'AUTH_ERROR';
export const SERVER_ERROR = 'SERVER_ERROR';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';

export const PROFILE_FETCH = 'PROFILE_FETCH';
export const PROFILE_FETCH_SUCCESS = 'PROFILE_FETCH_SUCCESS';
export const PROFILE_FETCH_FAILED = 'PROFILE_FETCH_FAILED';

export const PROFILE_UPDATE = 'PROFILE_UPDATE';
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS';
export const PROFILE_UPDATE_FAILED = 'PROFILE_UPDATE_FAILED';

export const REQUEST_ACTIVATION_CODE = 'REQUEST_ACTIVATION_CODE';
export const REQUEST_ACTIVATION_CODE_SUCCESS = 'REQUEST_ACTIVATION_CODE_SUCCESS';
export const REQUEST_ACTIVATION_CODE_FAILED = 'REQUEST_ACTIVATION_CODE_FAILED';

export const REQUEST_PROFILE_EDIT_CODE = 'REQUEST_PROFILE_EDIT_CODE';
export const REQUEST_PROFILE_EDIT_CODE_SUCCESS = 'REQUEST_PROFILE_EDIT_CODE_SUCCESS';
export const REQUEST_PROFILE_EDIT_CODE_FAILED = 'REQUEST_PROFILE_EDIT_CODE_FAILED';

export const REQUEST_EMAIL_EDIT_CODE = 'REQUEST_EMAIL_EDIT_CODE';
export const REQUEST_EMAIL_EDIT_CODE_SUCCESS = 'REQUEST_EMAIL_EDIT_CODE_SUCCESS';
export const REQUEST_EMAIL_EDIT_CODE_FAILED = 'REQUEST_EMAIL_EDIT_CODE_FAILED';

export const REQUEST_RESET_CODE = 'REQUEST_RESET_CODE';
export const REQUEST_RESET_CODE_SUCCESS = 'REQUEST_RESET_CODE_SUCCESS';
export const REQUEST_RESET_CODE_FAILED = 'REQUEST_RESET_CODE_FAILED';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';

export const VALIDATE_CODE = 'VALIDATE_CODE';
export const VALIDATE_CODE_SUCCESS = 'VALIDATE_CODE_SUCCESS';
export const VALIDATE_CODE_FAILED = 'VALIDATE_CODE_FAILED';

export const USER_PROFILE_CHANGE = 'USER_PROFILE_CHANGE';
export const USER_PROFILE_CHANGE_SUCCESS = 'USER_PROFILE_CHANGE_SUCCESS';
export const USER_PROFILE_CHANGE_FAILED = 'USER_PROFILE_CHANGE_FAILED';



// WEBPACK FOOTER //
// /src/redux/actions/actionTypes.js